// Exports
export default {
	"container": "container_+RUf2",
	"content": "content_X4x1E",
	"shadow": "shadow_2YjtS"
};
